import { render, staticRenderFns } from "./PageBackdrop.vue?vue&type=template&id=1c987377"
import script from "./PageBackdrop.vue?vue&type=script&lang=js"
export * from "./PageBackdrop.vue?vue&type=script&lang=js"
import style0 from "./PageBackdrop.vue?vue&type=style&index=0&id=1c987377&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports